import Home from './home';
import Toolbar from './components/toolbar';

function App() {
  return (
    <div>
      <Toolbar />
      <Home />
    </div>
  );
}

export default App;
